module.exports = __webpack_public_path__ + "img/Z61_12.4912ce34.jpg";